<div class="shop-product" [class]="'shop-product--' + item.type" [formGroup]="form">
	<a class="shop-product-description" (click)="showItem($event)" tabindex="0" (keydown.space)="showItem($event)" (keydown.enter)="showItem($event)">
		<img *ngIf="image" [src]="image" alt="" aria-hidden="true">
		<h2 [innerHTML]="item.name"></h2>
		<p [innerHTML]="item.description | nl2br"></p>
	</a>
	
	<!-- purchasable product -->
	<div class="row column" *ngIf="item.type === 'product' && asProduct(item).file && item.isPurchasable">
		<a class="download-link" (click)="showDownload()" tabindex="0" (keydown.space)="showDownload()">
			<i class="twingle-download"></i>{{ 'shop.download.pdf' | translate }}
		</a>
	
		<div class="mail-hint">
			{{ 'shop.brochure.mail' | translate }}
		</div>
	</div>
	<div class="row column" *ngIf="item.isPurchasable" [class.no-input]="textinput !== true && freePrice !== true" [class.price-wrapper]="textinput === true" [class.has-download]="item.file">
		<strong class="shop-price small-4" *ngIf="freePrice === false">{{item.price | number: priceFormat}} {{currency}}</strong>
		<div class="shop-price free-price" *ngIf="freePrice === true">
			<p class="infotext top" *ngIf="showInputError" [innerHTML]="'gift.item.freeprice.error' | translate"></p>
			<input type="number" name="amount" formControlName="price" (keydown.enter)="addItemToChart()" [placeholder]="'gift.item.freeprice.placeholder' | translate" [min]="freePriceMin" [max]="priceMax">
			<span>{{currency}}</span>
		</div>
		<div class="shop-price textinput" *ngIf="textinput === true">
			<p class="infotext top" *ngIf="showInputError" [innerHTML]="'shop.item.textinput.error' | translate"></p>
			<input
				type="text"
				formControlName="textinput"
				name="your-text"
				[maxlength]="textinputMaxLength"
				(keydown.enter)="addItemToChart()"
				[placeholder]="'shop.item.textinput.placeholder' | translate"
				[attr.aria-label]="'shop.item.textinput.placeholder' | translate"
			>
		</div>
	</div>
	<div class="row collapse cart-change"  *ngIf="item.isPurchasable" [class.added]="added">
		<p class="infotext top fade-in-delayed" *ngIf="availabilityInfoShownProduct" aria-hidden="true">
			{{ 'shop.info.product.max' | translate : {max: item.getMaxCount()} }}<i class="twingle-X" tabindex="0" (keydown.space)="availabilityInfoShownProduct = false" (click)="availabilityInfoShownProduct = false"></i>
		</p>
		<p class="infotext top fade-in-delayed" *ngIf="availabilityInfoShownBundle" aria-hidden="true">
			{{ 'shop.info.bundle.max' | translate }}<i class="twingle-X" tabindex="0" (keydown.space)="availabilityInfoShownBundle = false" (click)="availabilityInfoShownBundle = false"></i>
		</p>
		<span class="added small-12" aria-hidden="true">{{'shop.item.added' | translate}}</span>
		<ng-container *ngIf="(freePrice === false && textinput === false) || showCountInput">
			<div class="column small-4">
				<shop-amount-select
					[maxAmount]="availableCount"
					[itemCount]="itemCount"
					[itemName]="item.name"
					(amountChange)="changeItemCount($event)"
					[isDisabled]="availableCount < 1"
					[forceMax]="true"
				></shop-amount-select>
			</div>
		</ng-container>
		
		<div class="column" [class.small-12]="(freePrice === true || textinput === true) && !showCountInput" [class.small-8]="(freePrice === false && textinput === false) || showCountInput" [class.amount-before]="(freePrice === false && textinput === false) || showCountInput">
			<button class="button button-normalcase" [disabled]="availableCount === 0" [class.free-price]="(freePrice === true) && !showCountInput" (click)="addItemToChart()">
				<i class="twingle-add-to-shopping-cart"></i>{{'shop.item.add' | translate}}
			</button>
		</div>
	</div>

	<!-- non purchasable product with download -->
	<div class="row collapse download-button" *ngIf="!item.isPurchasable && item.type === 'product' && asProduct(item).file">
		<button class="button button-normalcase" (click)="showDownload()">
			<i class="twingle-download"></i> {{ 'shop.download.pdf' | translate }}
		</button>
	</div>
</div>
